import { getCookieByName } from '../utils/functions';

export function useCookieLensAdvisor() {
  const laContentCookie = getCookieByName('la-content', false);
  const laSurveyCookie = getCookieByName('la-survey', false);
  const laRulesCookie = getCookieByName('la-rules', false);
  const laStyleCookie = getCookieByName('la-style', false);
  const laStandaloneCookie = getCookieByName('la-standalone', true);

  const cookieReturn = {
    laContent: laContentCookie,
    laSurvey: laSurveyCookie,
    laRules: laRulesCookie,
    laStyle: laStyleCookie,
    laStandalone: laStandaloneCookie,
  };
  return cookieReturn;
}
